__turbopack_context__.v({
  "container": "jumbotron-module-scss-module__kovYYq__container",
  "containerDesc": "jumbotron-module-scss-module__kovYYq__containerDesc",
  "containerTitle": "jumbotron-module-scss-module__kovYYq__containerTitle",
  "descContentClamped": "jumbotron-module-scss-module__kovYYq__descContentClamped",
  "toggleLabel": "jumbotron-module-scss-module__kovYYq__toggleLabel",
});
